if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
           console.log('Add to Cart button clicked');
             var freeGiftElement = document.querySelector(".free_giftEnabled");
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          // formData.append('', 4193714424);
          this.cart.setActiveElement(document.activeElement);
        }
       
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id') });
            // Fetch the cart data to add free gift
    // Add a small delay to ensure cart is fully updated
    setTimeout(function() {
    fetch('/cart.js')
  .then(response => response.json())
  .then(parsedState => {
    // Get all free gift variant IDs first (as numbers for consistent comparison)
    var freeGiftVariantIds = [];
    var freeGiftElement = document.querySelector(".free_giftEnabled");
    var freeGiftElements = document.querySelector(".free_giftEnableds");
    
    if (freeGiftElement) {
      freeGiftVariantIds.push(parseInt(freeGiftElement.getAttribute('data-freeitemid'), 10));
    }
    if (freeGiftElements) {
      freeGiftVariantIds.push(parseInt(freeGiftElements.getAttribute('data-freeitemids'), 10));
    }
    
    // Calculate total price EXCLUDING free gift items
    var totalPriceExcludingGifts = parsedState.items.reduce(function(total, item) {
      // Convert variant_id to number for comparison
      var itemVariantId = parseInt(item.variant_id, 10);
      if (freeGiftVariantIds.indexOf(itemVariantId) === -1) {
        return total + (item.final_line_price || item.line_price);
      }
      return total;
    }, 0) / 100;
    
    // Get count of non-free-gift items
    var nonGiftItemCount = parsedState.items.filter(function(item) {
      var itemVariantId = parseInt(item.variant_id, 10);
      return freeGiftVariantIds.indexOf(itemVariantId) === -1;
    }).length;
    
    console.log('Free gift check - Total excluding gifts:', totalPriceExcludingGifts, 'Non-gift items:', nonGiftItemCount, 'Free gift variant IDs:', freeGiftVariantIds);
    
    // CRITICAL: Only proceed if cart has non-free-gift items and total > 0
    if (nonGiftItemCount === 0 || totalPriceExcludingGifts <= 0) {
      console.log('Skipping free gift logic - cart is empty or has no non-gift items');
      return;
    }
    
     // Check for second free gift element
    if (freeGiftElements) {
      // Get the variant ID and target price for the second free gift
      var variantid2 = parseInt(freeGiftElements.getAttribute('data-freeitemids'), 10);
      var freeTarget2 = freeGiftElements.getAttribute('data-target');
      var targetvals2 = parseFloat(freeTarget2) / 100;
      
      console.log('Second gift check - Target:', targetvals2, 'Current total:', totalPriceExcludingGifts);
      
      // Check if the second free gift item is already in the cart
      var freeGiftExists2 = parsedState.items.some(function(item) {
        return parseInt(item.variant_id, 10) === variantid2;
      });

     if(totalPriceExcludingGifts >= targetvals2){
             //add the free gift if not exist already
              if (!freeGiftExists2) {
                console.log('Adding second free gift - threshold met');
                $('.add_freeGiftss').trigger('click');
              } else {
             console.log('Free gift already exists in the cart.');
            }
             
           }else{
             //remove the free gift if exist already
             if (freeGiftExists2) {
              console.log('Total price is below the target. Removing first free gift...');
              $('.remove_freeGiftss').trigger('click');
            } else {
            console.log('Free gift not in the cart, no need to remove.');
            }
          }
    }

        // Check for first free gift element
    if (freeGiftElement) {
      // Get the variant ID and target price for the free gift
      var variantid = parseInt(freeGiftElement.getAttribute('data-freeitemid'), 10);
      var freeTarget = freeGiftElement.getAttribute('data-target');
      var targetvals = parseFloat(freeTarget) / 100;

      console.log('First gift check - Target:', targetvals, 'Current total:', totalPriceExcludingGifts);

      // Check if the free gift item is already in the cart
      var freeGiftExists = parsedState.items.some(function(item) {
        return parseInt(item.variant_id, 10) === variantid;
      });

      if (totalPriceExcludingGifts >= targetvals) {
        // Add the free gift if it doesn't already exist
        if (!freeGiftExists) {
          console.log('Adding first free gift - threshold met');
          $('.add_freeGifts').trigger('click');
        } else {
          console.log('Free gift already exists in the cart.');
        }
      } else {
        // Remove the free gift if it exists and the total price is below target
        if (freeGiftExists) {
          console.log('Total price is below the target. Removing first free gift...');
          $('.remove_freeGifts').trigger('click');
        } else {
          console.log('Free gift not in the cart, no need to remove. Total:', totalPriceExcludingGifts, 'Target:', targetvals);
        }
      }
    }
  
 
  })
  .catch(error => console.error('Error fetching cart data:', error));
    }, 500); // Wait 500ms for cart to update


// end of free gift
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
